.rows {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--mantine-spacing-sm) 0;
  border-bottom: 1px solid var(--adl-border-light);
}

.row:last-child {
  border-bottom: none;
}

.label {
  font-size: var(--mantine-font-size-sm);
  color: var(--adl-text-primary);
}
